import * as React from 'react'
import { compose, pure } from 'recompose'
import { NO_IMAGE_URL } from '../../../../commons/Const'
import { isEmpty } from '../../../../commons/formValidator'
import Image from '../../atoms/Image/Image'
import * as styles from './ImageButton.css'

interface ImageButtonProps {
  handleClick: () => void
  imagePath: string | null
}

const ImageButton: React.FunctionComponent<ImageButtonProps> = ({ handleClick, imagePath = null }) => (
  <div className={styles.imageButton} onClick={handleClick}>
    <Image src={isEmpty(imagePath) ? NO_IMAGE_URL : imagePath} isRadius={false} isContain={true} />
  </div>
)

export default compose(pure)(ImageButton)
